import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import { provideRouter, withComponentInputBinding } from '@angular/router'

import { routes } from './app.routes'
import { provideNzIcons } from './icons-provider'
import { ru_RU, provideNzI18n, NZ_DATE_LOCALE } from 'ng-zorro-antd/i18n'
import { ru } from 'date-fns/locale'
import { FormsModule } from '@angular/forms'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { authInterceptor } from '@core/auth.interceptor'
import { provideToastr } from 'ngx-toastr'
import { provideAnimations } from '@angular/platform-browser/animations'
import { errorInterceptor } from '@core/error.interceptor'

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withComponentInputBinding()),
        importProvidersFrom(FormsModule),
        provideAnimations(),
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptors([authInterceptor, errorInterceptor])
        ),
        provideNzIcons(),
        provideNzI18n(ru_RU),
        { provide: NZ_DATE_LOCALE, useValue: ru },
        provideToastr(),
    ],
}
